import { SVGProps, Ref, forwardRef } from 'react';

export const SmileFaceOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.032 10.664c0 .098.038.21.143.32.158.169.45.313.823.313s.665-.144.823-.312a.47.47 0 0 0 .143-.32h1.4c0 .501-.209.944-.523 1.278-.45.48-1.126.754-1.843.754s-1.393-.274-1.844-.754a1.86 1.86 0 0 1-.522-1.279z"
                fill="currentColor"
            />
            <path
                d="M4.677 5.466c.205-.246.527-.4.988-.4.462 0 .784.154.988.4.202.242.279.56.279.866s-.077.623-.279.866c-.204.245-.526.4-.988.4s-.783-.155-.988-.4c-.202-.243-.278-.56-.278-.866 0-.307.076-.624.278-.866"
                fill="currentColor"
            />
            <path
                d="M9.343 5.466c.204-.246.526-.4.988-.4s.783.154.988.4c.202.242.278.56.278.866s-.076.623-.278.866c-.205.245-.527.4-.988.4-.462 0-.784-.155-.988-.4-.202-.243-.279-.56-.279-.866 0-.307.077-.624.279-.866"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5M3.216 3.74C2.32 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26C4.076 13.291 5.524 14.1 8 14.1s3.925-.809 4.784-1.84C13.68 11.184 14.1 9.667 14.1 8s-.42-3.184-1.316-4.26C11.924 2.709 10.476 1.9 8 1.9s-3.925.809-4.784 1.84"
                fill="currentColor"
            />
        </g>
    </svg>
));
SmileFaceOutlinedSize16Glyph.displayName = 'SmileFaceOutlinedSize16Glyph';
